import {createStore, applyMiddleware} from "redux";
import { persistCombineReducers, persistReducer } from "redux-persist";
import AsyncStorage from '@react-native-community/async-storage';
// import storageSession from 'redux-persist/es/storage/session'
import thunk from 'redux-thunk'

import themeReducer from "./Reducers/themeReducer"
import AuthReducer from "./Reducers/AuthReducer";
import tendanceReducer from "./Reducers/tendanceReducer";
import notificationReducer from "./Reducers/NotificationReducer";
import SwReducer from "./Reducers/SwReducer";


const reducers = {
  changeTheme: themeReducer,
  AuthReducer,
  tendanceReducer,
  notificationReducer,
  sw_reducer: SwReducer
};

const rootPersistConfig = {
    key : 'root',
    storage : AsyncStorage,
    // FIXME: does not work well for now as the application is already displayed...
    // we will need to refresh once the app
    // blacklist: ["changeTheme"] // the themeReducer takes care of himself
}


const persistedReducers = persistCombineReducers(rootPersistConfig, reducers);

const store = createStore(persistedReducers, applyMiddleware(thunk))

export default store;
